<template>
  <g transform="translate(-12, -12)">
    <g id="background">
      <polygon :fill="color" points="5.7,0.8 12.1,3.9 18.5,0.8 23.7,3.4 23.7,11.8 20.8,17.1 12.1,23.2 3.2,17 0.3,11.6 0.3,3.3"/>
    </g>
    <g id="outline">
      <path fill="#1a2b4a" d="M24,11.9V3.1l-5.6-2.9L12,3.5L5.6,0.3l0,0L0,3.1v8.8l3,5.5l9,6.3l9-6.3L24,11.9z M23.3,3.6v7.9h-4.5V1.3
        L23.3,3.6z M18,1.3v10.2h-5.7V4.2l0,0L18,1.3z M11.6,11.5H6v-4l5.7-2.9V11.5z M11.6,12.2L11.6,12.2l0,4.3l-5.4-3.3l-0.2-1H11.6z
        M6,6.6V1.3L11.2,4L6,6.6z M12.4,12.2H18l-1.5,7.2l-4.1-2.5L12.4,12.2z M7.6,19.4l-1.1-5.2L7.8,15l3.5,2.2l-2.8,1.7L7.6,19.4z
        M0.7,3.6l4.5-2.3v10.2H0.7V3.6z M1,12.2h4.3l0.3,1.5l0,0l1.1,5.5l-3.2-2.3L1,12.2z M12,22.8L8,20l1.4-0.9l2.6-1.6l4.1,2.5L12,22.8
        z M20.4,16.9l-3.1,2.2l1.4-7H23L20.4,16.9z"/>
    </g>
  </g>
</template>

<script>
export default {
  name: 'HeartIcon',
  props: {
    color: String,
  },
}
</script>

<style lang="scss" scoped>
</style>
